import { buildApiUrl, ADMIN_ENDPOINTS } from '@/project/configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.REWARD_RULE_DELETE, { pathParams: { id: payload.id } })
  },

  method() {
    return 'DELETE'
  },

  format(payload) {
    return {}
  },

  parse(raw = {}) {
    if (raw?.statusCode !== 200 && raw?.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        success: false,
        message: raw?.message || 'Erreur lors de la suppression de la règle',
      }
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Règle supprimée avec succès',
      data: raw?.data,
    }
  },
}
